<div class="move-to-group-dialog">

  <h1 mat-dialog-title class="dialog-title">Move to group</h1>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message">
      {{ data.pupilName }} is not in an active group, so no school restriction reaches them.
      Choose the group they should join.
    </p>

    <mat-form-field appearance="outline" class="full-width" *ngIf="groups.length > 0">
      <mat-label>Group</mat-label>
      <mat-select [(ngModel)]="selectedGroupId">
        <mat-option *ngFor="let group of groups" [value]="group.id">{{ group.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="dialog-message" *ngIf="groups.length === 0">
      Your school has no active group yet. Create one first.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectedGroupId" (click)="confirm()">Move</button>
  </mat-dialog-actions>
</div>
